<template>
  <v-container>
    <div class="mx-auto share-wrap">
      <div class="brand-banner mb-5" v-if="campaignData.campaign&&campaignData.campaign.assets">
        <v-carousel
          :show-arrows="campaignData.campaign.assets.imgs.length > 1"
          hide-delimiters
          show-arrows-on-hover
          class="carousel-wrap"
        >
          <v-carousel-item
            v-for="(item,i) in campaignData.campaign.assets.imgs"
            :key="i"
            :src="item.url"
            reverse-transition="fade-transition"
            transition="fade-transition"
          >
            <div class="times body-1">
              <span>
                {{campaignData.campaign.startDate | formatUTCLocalDate}}
                &nbsp;～&nbsp;
                {{campaignData.campaign.endDate | formatUTCLocalDate}}
              </span>
            </div>
          </v-carousel-item>
        </v-carousel>
        <p class="title subtitle-1 text-line">{{campaignData.campaign.brand.name}}</p>
        <p class="brand-name body-1 text-line">{{campaignData.campaign.name}}</p>
        <div class="brand-tools body-1 text-line">
          <div>
            <v-icon small color="#4C28D0">mdi-pencil</v-icon>
            {{$t( 'brands.'+ campaignData.campaign.contextType)}}
          </div>
          <div>
            <v-icon small color="#4C28D0">mdi-map-marker</v-icon>
            {{allArea[campaignData.campaign.targetAreas[0]]}}
          </div>
        </div>
      </div>
      <div class="line-bg"></div>
      <div class="brand-intro mb-5 pt-5">
        <v-tabs v-model="tab" background-color="white" color="#4C28D0" grow>
          <v-tab
            v-for="item in items"
            :key="item"
            class="subtitle-1 font-weight-black text-capitalize"
          >{{ $t( 'brands.'+item) }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="item in items" :key="item">
            <v-card color="basil" class="px-0 py-4" flat>
              <v-card-text class="px-0 py-0 my-4 line-camp-8">{{ getInfoText(item) }}</v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <div class="line-bg"></div>
      <div class="brand-recom pb-16" v-if="campaignData.recommendations">
        <v-row class="px-md-5 py-md-12" v-if="campaignData.recommendations.length > 0">
          <v-col md="12" xs="12" sm="12" class="mb-2">
            <h3>{{$t('brands.brandRocTitle')}}</h3>
          </v-col>
          <v-col
            md="4"
            sm="4"
            xs="4"
            v-for="(item, index) in campaignData.recommendations"
            :key="index"
          >
            <v-hover>
              <template v-slot="{ hover }">
                <v-card class="mx-auto rounded-lg" :elevation="hover ? 4 : 0">
                  <v-img
                    :lazy-src="prixUrl + item.assets.imgs[0].url"
                    height="200" :src="prixUrl + item.assets.imgs[0].url"></v-img>
                  <v-card-title
                    class="d-inline-block text-truncate"
                    style="max-width: 100%;"
                  >{{item.brand.name}}</v-card-title>
                </v-card>
              </template>
            </v-hover>
          </v-col>
        </v-row>
        <div class="px-md-5">
          <v-card class="rounded-lg py-8 px-4" flat color="#f7f7f7">
            <div class="img">
              <img class="m-auto" src="../assets/logo.png" />
            </div>
            <v-card-title color="#201F4B">{{$t('brands.naviInfo')}}</v-card-title>
          </v-card>
        </div>
      </div>
    </div>
    <v-footer fixed color="white" class="py-4 px-5 footer-wrap d-flex justify-space-center">
      <div class="m-auto d-flex align-center justify-space-between px-8">
        <span class="font-weight-medium subtitle-1">$ {{getBuget}}</span>
        <v-btn
          large
          color="primary"
          elevation="0"
          class="rounded-pill text-capitalize"
          @click.stop="dialogApply = true"
        >{{$t('brands.application')}}</v-btn>
      </div>
    </v-footer>
    <v-dialog max-width="600" v-model="dialogApply">
      <v-card class="py-12 px-2">
        <v-card-title class="headline subtitle-1">{{$t('brands.'+ getCampainStatus)}}</v-card-title>
        <div class="applay-wrap py-5">
          <v-btn
            color="primary"
            elevation="0"
            class="rounded-pill text-capitalize"
            @click="handleOpen"
          >{{$t('brands.login')}}</v-btn>
        </div>
        <v-card-text>
          <b class="subtitle-1 font-weight-bold">Tips:</b>
          <span class="subtitle-2">{{$t('brands.tipMobile')}}</span>
        </v-card-text>

        <div class="copy-wrap px-6">
          <v-row>
            <v-col md="10" :xs="10" :sm="10">
              <v-btn
                outlined
                rounded
                disabled
                block
                class="subtitle-2 text-line some text-lowercase"
              >{{kolUrl}}</v-btn>
            </v-col>
            <v-col md="2" :xs="2" sm="2" class="text-center">
              <v-btn
                type="button"
                class="text-lowercase"
                v-clipboard:copy="kolUrl"
                text
                color="primary"
                v-clipboard:success="onCopy"
              >{{$t('brands.copy')}}</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="info" :top="true">{{ $t('brands.copySuc')}}</v-snackbar>
  </v-container>
</template>
<script>
import axios from 'axios';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
// todo fix 复制链接在弹出框复制不生效的问题
VueClipboard.config.autoSetContainer = true;

Vue.use(VueClipboard);

export default {
  name: 'Campaigns',
  data: () => ({
    loading: false,
    selection: 1,
    campaignData: {},
    tab: null,
    items: ['brandInrol', 'productInfo'],
    dialogApply: false,
    kolUrl: `${process.env.VUE_APP_NAVIGATE_KOL}login`,
    snackbar: false,
    lang: 'zh-cn',
    allArea: null,
    prixUrl: 'https://res.cloudinary.com/twodm/image/fetch/',
  }),
  created() {
    this.fieldsManager();
    this.fetchCampaignPreviewData();
    this.lang = this.$i18n.locale;
  },
  mounted() {
    window.Intercom('update', {
      hide_default_launcher: true,
    });
  },
  computed: {
    getBuget() {
      return (
        Math.floor(this.campaignData.campaign.budget * 100) / 100
      ).toFixed(2);
    },
    getCampainStatus() {
      return this.campaignData.campaign.status; // inProgress  cancelled finished
    },
  },
  methods: {
    handleOpen() {
      window.open(this.kolUrl);
    },
    onCopy() {
      this.snackbar = true;
    },
    getInfoText(str) {
      if (str === 'brandInrol') {
        return this.campaignData.campaign.brand.description;
      }
      return this.campaignData.campaign.productDescription;
    },
    reserve() {
      this.loading = true;
      // eslint-disable-next-line no-return-assign
      setTimeout(() => (this.loading = false), 2000);
    },
    fieldsManager() {
      axios
        .get(`${process.env.VUE_APP_TRACKING_ROOT}/field-manager`, {
          headers: {
            language: 'zh', // this.lang,
          },
        })
        .then((res) => {
          if (res.data) {
            this.allArea = res.data.areaAll.data;
            // this.allArea =             console.log(res.data, 889);
          } else {
            this.$router.push('/404');
          }
        });
    },
    fetchCampaignPreviewData() {
      axios
        .get(
          `${process.env.VUE_APP_TRACKING_ROOT}/campaigns/share/${this.$route.params.id}`,
        )
        .then((res) => {
          if (res.data) {
            this.campaignData = res.data;
          } else {
            this.$router.push('/404');
          }
        });
    },
  },
};
</script>


<style lang="scss" scoped>
.text-line {
  overflow: hidden;
  /*文本不会换行*/
  white-space: nowrap;
  /*当文本溢出包含元素时，以省略号表示超出的文本*/
  text-overflow: ellipsis;
}
.container {
  max-width: 46.875rem /* 750/16 */;
  min-height: 100vh;
  background: white;
  .brand-banner {
    background: white;
    padding-bottom: 1.25rem /* 20/16 */;
    .carousel-wrap {
      height: auto;
      .times {
        color: white;
        background: rgba(0, 0, 0, 0.2);
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        align-content: center;
        padding: 0.625rem /* 10/16 */ 1.25rem /* 20/16 */;
      }
    }
    .title {
      font-weight: 600;
      color: #333;
      font-size: 1.125rem /* 18/16 */;
      padding: 1rem /* 16/16 */ 1.25rem /* 20/16 */ 0 1.25rem /* 20/16 */;
    }
    .brand-name {
      font-weight: 400;
      line-height: 2.875rem /* 46/16 */;
      color: #333;
      padding: 0 1.25rem /* 20/16 */;
    }
    .brand-tools {
      display: flex;
      padding: 0 1.25rem /* 20/16 */;
      & > div {
        flex-grow: 1;
        color: #4c28d0;
      }
    }
    .subtitle-1,
    .body-1 {
      margin-bottom: 0;
    }
  }
  .brand-recom {
    background: white;
    .img {
      text-align: center;
      img {
        max-width: 60%;
        max-height: 5rem /* 80/16 */;
      }
    }
  }
  .line-bg {
    height: 2px;
    width: 100%;
    background: #f7f7f7;
  }
  .footer-wrap {
    box-shadow: 10px 0px 5px 3px rgba(0, 0, 0, 0.16);
    > div {
      width: 100%;
      max-width: 750px;
      margin: 0 auto;
      .primary {
        background-color: #4c28d0 !important;
      }
    }
    span {
      color: #4c28d0;
    }
  }
}
.applay-wrap {
  text-align: center;
  .primary {
    background-color: #4c28d0 !important;
  }
}
.copy-wrap {
  // display: flex;
  .some {
    border-color: #4c28d0 !important;
    color: #4c28d0 !important;
  }
  .theme--light.v-btn.v-btn--disabled {
    border-color: #4c28d0 !important;
    color: #4c28d0 !important;
    color: #4c28d0;
  }
  .primary--text {
    caret-color: #4c28d0 !important;
    color: #4c28d0 !important;
  }
}
</style>
<style>
.v-dialog {
  overflow: hidden !important;
}
.line-camp-8 {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
}
</style>
